/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import DataWidget from "../DataWidget";
import DataTable from "../../../pages/Resource/DataTable/DataTable";

class ViewArray extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider.getProvider(this.props.field);

        let rows = dataProvider.getRowCount();
        let items = [];
        for (let i = 0; i < rows; i++) {
            let childDataProvider = dataProvider.getProvider(i);
            items.push((<li key={i}><DataWidget dataProvider={childDataProvider} field={null} /></li>));
        }
        return items;
    }

    render() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider.getProvider(this.props.field);
        let schema = dataProvider.getSchema();
        let data = dataProvider.getData();
        return (
            <DataTable
                schema={schema}
                data={data}
                pageSize={0}
                size="small"
                internalSort={true}
            />
        );
        /*
        return (
            <ul>
                {this.renderItems()}
            </ul>
        );
        */
    }
}

export default ViewArray;
